import Link from '@commons/components/Link';
import Text from '@commons/components/Text';

import type { WebinarNodeProps } from '.';
import { WebinarNodeButtonLink } from './GatedDrawer';

/**
 * Webinar node component for the Label display type.
 */

const WebinarNodeLabel = ({ title, link, isGated }: WebinarNodeProps) => {
  if (!link) {
    return <Text>{title}</Text>;
  }

  if (isGated) {
    return (
      <WebinarNodeButtonLink link={link} isGated={isGated} ctaLabel={title} variant="tertiary" />
    );
  }

  return <Link href={link.url}>{title}</Link>;
};

export default WebinarNodeLabel;
